export default {
  homeHeroTitle: '标准化心理测评工具与专业培训服务',
  homeHeroDesc: '我们建立中国本土常模数据，深度联动全球高校、医疗机构与科研院所，研发兼具专业性与本土适配性的心理测评工具及整体解决方案。',
  homeProductTagline: '标准化 · 心理量表',
  homeProductDesc: '我们提供包括神经发育障碍、适应行为、运动发展、学习困难等专业的评估量表，构建了自婴儿至老年的全生命周期标准化心理评估工具。',
  homeTrainingTagline: '新技术 · 培训课程',
  homeTrainingDesc: '我们持续为客户提供由心理学、教育学、临床医学、康复医学等领域内权威专家担任讲师的高价值、高频次的培训课程。',
  homeExpertTagline: '业界权威 · 研发智库',
  homeExpertDesc: '我们建立了由心理学、教育学、临床医学、康复医学专家组成的权威研发团队。'
}



// WEBPACK FOOTER //
// ./src/i18n/locales/zh/home.js